import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/ui/Icon'
import { useGetSetting } from 'api/settings'

export type WidgetFileUploadProps = {
  onFilesAdded: (files: File[]) => void
  disable?: boolean
  /** Restricts the native picker to specific types (e.g. bot attachments allow-list). */
  accept?: string
}

export const WidgetFileUpload = ({ onFilesAdded, disable, accept }: WidgetFileUploadProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null)
  const { setting } = useGetSetting()
  const { t } = useTranslation()

  return (
    <div>
      <input
        type="file"
        ref={inputFileRef}
        multiple={true}
        accept={accept}
        disabled={disable}
        onChange={(e) => {
          const newFiles = e.target.files
          if (newFiles) {
            onFilesAdded(Array.from(newFiles))
          }
          // Allow re-picking the same file
          e.target.value = ''
        }}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        aria-label={t('uploadFile')}
        className={`tw-inline-flex tw-justify-center tw-items-center tw-w-[40px] tw-h-[40px] tw-rounded-[8px]`}
        style={{ color: setting?.primaryColor || 'var(--icon-default)' }}
        disabled={disable}
        onClick={() => inputFileRef.current?.click()}
      >
        <Icon icon={['far', 'plus']} className="tw-h-5 tw-w-5" />
      </button>
    </div>
  )
}
